export default Object.freeze({
    CREATED: 'created',
    SUCCEED: 'succeed',
    FAILED: 'failed',    
  })